import imageOne from '../images/outside-area-1.jpg';
import imageTwo from '../images/outside-area-2.jpg';
import imageThree from '../images/home-interior-1.jpg';
import imageFour from '../images/outside-area-3.jpg';

export const SliderImages = [
    {
        image: imageOne
    },
    {
        image: imageTwo
    },
    {
        image: imageThree,
    },
    {
        image: imageFour,
    },
];